import React from 'react'
import { isEmpty, isNil, anyPass } from 'ramda'
import PropTypes from 'prop-types'
import momentTimezone from 'moment-timezone'
import { FormattedMessage } from 'react-intl'
import { Typography } from '@material-ui/core'

import { changeTimezone } from 'libs/dateUtils'
import { timeFormat, dateFormat } from 'commons/date'

import { CalendarClockIcon } from 'app/components/icons'

const EventDate = (props) => {
  const { data } = props
  const { startDate, endDate, startTimeZone, endTimeZone } = data

  const handleEventDate = (
    startDateTime,
    endDateTime,
    stratTimezone,
    endTimezone,
  ) => {
    const startDate = changeTimezone(startDateTime, stratTimezone).format(
      dateFormat,
    )
    const startTime = changeTimezone(startDateTime, stratTimezone).format(
      timeFormat,
    )
    const startOffsets = momentTimezone.tz(stratTimezone).format('Z')

    if (anyPass([isNil, isEmpty])(endDateTime)) {
      return (
        <FormattedMessage
          id="label.date.utc"
          values={{ date: startDate, time: startTime, offsets: startOffsets }}
        />
      )
    } else {
      const endDate = momentTimezone(endDateTime)
        .tz(endTimezone)
        .format(dateFormat)
      const endTime = momentTimezone(endDateTime)
        .tz(endTimezone)
        .format(timeFormat)
      const endOffsets = momentTimezone.tz(endTimezone).format('Z')

      return (
        <FormattedMessage
          id="label.start.to.until.date.utc"
          values={{
            startDate,
            startTime,
            startOffsets,
            endDate,
            endTime,
            endOffsets,
          }}
        />
      )
    }
  }

  return (
    <>
      {isNil(data) ? null : (
        <Typography
          component="p"
          className="break-word text-grey-300 text-12 flex item-center"
        >
          <span className="mr-3">
            <CalendarClockIcon />
          </span>
          {handleEventDate(startDate, endDate, startTimeZone, endTimeZone)}
        </Typography>
      )}
    </>
  )
}

EventDate.propTypes = {
  data: PropTypes.shape({
    startDate: PropTypes.string,
    endDate: PropTypes.string,
    startTimeZone: PropTypes.string,
    endTimeZone: PropTypes.string,
  }),
}

export default EventDate
